<template>
  <div>
    <div class="mb-2" v-if="item.columnType === 'Text'">
      <p class="mb-1" :class="item.require && 'required'">{{ item.title }}</p>
      <ValidationProvider
        v-if="item.title === 'Số điện thoại'"
        :name="item.title"
        :rules="item.require ? `required-phone` : `phone`"
        v-slot="{ errors }"
      >
        <el-input :disabled="disable" v-model="internalValue" @input="updateValue($event)" @keydown.native="handleKeyDown" :placeholder="`Nhập thông tin trường ${item.title}`"></el-input>
        <InputError :message="errors[0]" />
      </ValidationProvider>
      <ValidationProvider
        v-else-if="item.title === 'Email'"
        :name="item.title"
        :rules="`email`"
        v-slot="{ errors }"
      >
        <el-input :disabled="disable" v-model="internalValue" @input="updateValue($event)" :placeholder="`Nhập thông tin trường ${item.title}`"></el-input>
        <InputError :message="errors[0]" />
      </ValidationProvider>
      <ValidationProvider
        v-else
        :name="item.title"
        :rules="item.require ? `required-input:${item.title}` : ''"
        v-slot="{ errors }"
      >
        <el-input :disabled="disable" v-model="internalValue" @input="updateValue($event)" :placeholder="`Nhập thông tin trường ${item.title}`"></el-input>
        <InputError :message="errors[0]" />
      </ValidationProvider>
    </div>
    <div class="mb-2" v-if="item.columnType === 'Number'">
      <p class="mb-1" :class="{ 'required' : item.require }">{{ item.title }}</p>
      <ValidationProvider
        :name="item.title"
        :rules="item.require ? `required-number:${item.title}` : ''"
        v-slot="{ errors }"
      >
        <el-input :disabled="disable" v-model="internalValue" type="text"  @keypress.native="isNumber($event)" v-thousand-separator  :placeholder="`Nhập thông tin trường ${item.title}`"></el-input>
        <InputError :message="errors[0]" />
      </ValidationProvider>
    </div>
    <div class="mb-2" v-if="item.columnType === 'Date'">
      <p class="mb-1" :class="{ 'required' : item.require }">{{ item.title }}</p>
      <ValidationProvider
        ref="dateProvider"
        :name="item.title"
        :rules="item.require ? `required-input:${item.title}` : ''"
        v-slot="{ errors }"
      >
        <el-date-picker class="w-100 custom-pick-date" 
          v-model="internalValue" 
          @change="updateValue($event)"
          type="datetime" 
          :placeholder="`Nhập thông tin trường ${item.title}`"
          format="HH:mm:ss dd/MM/yyyy" 
          prefix-icon="icon-date-1"
          :clearable="false"
          :default-value="defaultDate"
          :disabled="disable"
        >
        </el-date-picker>
        <InputError :message="errors[0]" />
      </ValidationProvider>
    </div>
    <div class="mb-2" v-if="item.columnType === 'SingleSelect'">
      <div v-if="item.name !== 'storage'">
        <p class="mb-1" :class="{ 'required' : item.require }">{{ item.title }}</p>
        <ValidationProvider
          :name="item.title"
          :rules="item.require ? `required-select:${item.title}` : ''"
          v-slot="{ errors }"
        >
          <SelectCustom 
            :disable = "disable"    
            :options="item.selectOptions"
            :code = "item.name"
            :companyCode = "app.user.companyCode"
            v-model="internalValue"
            :placeholder="`Chọn dữ liệu trường ${item.title}`"
          />
          <InputError :message="errors[0]" />
        </ValidationProvider>
      </div>
      <div v-if="item.name === 'storage'">
        <p class="mb-1" :class="{ 'required' : item.require }">{{ item.title }}</p>
        <ValidationProvider
          :name="item.title"
          :rules="item.require ? `required-select:${item.title}` : ''"
          v-slot="{ errors }"
        >
          <SelectStorage 
            :disable = "disableStorage || disable"    
            :options="storageList"
            v-model="internalValue"
            :placeholder="`Chọn dữ liệu trường ${item.title}`"
          />
          <InputError :message="errors[0]" />
        </ValidationProvider>
      </div>
    </div>
    <div class="mb-2" v-if="item.columnType === 'Employees'">
      <p class="mb-1" :class="{ 'required' : item.require }">Nhân viên</p>
      <ValidationProvider
        :name="item.title"
        :rules="item.require ? `required-select:${item.title}` : ''"
        v-slot="{ errors }"
      >
        <el-select
          :disabled="disable"
          class="w-100"
          v-model="internalValue"
          collapse-tags
          filterable
          multiple
          @change="updateEmployeeValue($event)"
          :placeholder="`Chọn dữ liệu trường ${item.title}`">
          <el-option
            v-for="option in employeeOptions"
            :key="option.id"
            :label="employeeShortName(option)"
            :value="option.id"
            :disabled="option.locked">
          </el-option>
        </el-select>
        <InputError :message="errors[0]" />
      </ValidationProvider>    
    </div>
    <div class="mb-2" v-if="item.columnType === 'MultiSelect'">
      <p class="mb-1" :class="{ 'required' : item.require }">{{ item.title }}</p>
      <ValidationProvider
        :name="item.title"
        :rules="item.require ? `required-select:${item.title}` : ''"
        mode="lazy"
        v-slot="{ errors }"
      >
        <MultiSelectCustom 
          :disable = "disable"
          @change="updateValue($event)"
          :options="item.selectOptions"
          :code = "item.name"
          :companyCode = "app.user.companyCode"
          v-model="internalValue"
          :placeholder="`Chọn dữ liệu trường ${item.title}`"/>
        <InputError :message="errors[0]" />
      </ValidationProvider>
    </div>
    <!-- Array -->
    <div class="mb-2" v-if="item.columnType === 'Array' || item.columnType === 'ArrayNumber'">
      <p class="mb-1" :class="{ 'required' : item.require }">{{ item.title }}</p>
      <ValidationProvider
        :name="item.title"
        :rules="item.require ? `required-input-array:${item.title}` : ''"
        v-slot="{ errors }"
      >
        <el-select
          class="w-100"
          v-model="internalValue"
          @change="updateValue($event)"
          multiple
          allow-create
          filterable
          default-first-option
          placeholder="Nhập lựa chọn và bấm 'Enter'"
          @keydown.native="handleNumberInput"
        >
          <el-option
            v-for="i in selectOptions"
            :key="i.id"
            :label="i.value"
            :value="i.value"
          />
        </el-select>

        <InputError :message="errors[0]" />
      </ValidationProvider>
    </div>
  </div>
</template>

<script>
import SelectCustom from './SelectCustom.vue'; 
import MultiSelectCustom from './MultiSelectCustom.vue';
import SelectStorage from './SelectStorage.vue';
export default {
  components : {SelectCustom,MultiSelectCustom,SelectStorage},
  data () {
    return {
      internalValue: this.value,
      // Nhân viên của contact nằm ngoài quyền quản lý của người đang thao tác.
      unmanagedEmployees: [],
      selectionValue: '', 
      // selectOptions: [],
      arrayError : true,
    }
  },
  directives: {
    thousandSeparator: {
      bind(el, binding, vnode) {
        el.addEventListener('input', function(e) {
          let value = e.target.value.replace(/,/g, '');

          if (isNaN(value) || value.trim() === '') {
            vnode.context[binding.expression] = value;
            return;
          }

          vnode.context[binding.expression] = value;

          const [intPart, decimalPart] = value.split('.');
          const formatted = new Intl.NumberFormat('en-US').format(intPart);
          e.target.value = decimalPart !== undefined ? `${formatted}.${decimalPart}` : formatted;
        });
      }
    }
  },
  props: {
    item: {
      type: Object,
      required: true 
    },
    value: {  
      type: [String, Number, Array, Object,Date], 
      default: null
    },
    disableStorage: {
      type: Boolean,
      required: true
    },
    storageList: {
      type: Array,
      required: true
    },
    disable : {
      type: Boolean,
      required: true
    },
    selectOptions: {
      type : Array,
      require : true
    },
    // Nhân viên hiện có của contact (object hoặc id). Là nguồn chuẩn để biết
    // ai đang nằm ngoài quyền quản lý — không dựa vào giá trị form, vì có form
    // khởi tạo giá trị này không đáng tin.
    contactEmployees: {
      type: Array,
      default: () => []
    },
    // Bật ở những form gửi lên TOÀN BỘ danh sách nhân viên của contact
    // (cập nhật liên hệ, chuyển bước): nhân viên ngoài quyền quản lý được
    // hiển thị nhưng khoá lại để không bị gỡ mất khi lưu.
    lockUnmanagedEmployees: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    defaultDate() {
      return new Date();
    },
    employeeOptions() {
      const options = this.employeeOptionsForContact(this.unmanagedEmployees);
      if (this.lockUnmanagedEmployees) return options;
      // Không khoá thì chỉ cần có mặt trong options để el-select hiển thị đúng
      // tên thay vì id trần, vẫn cho phép bỏ chọn.
      return options.map(option => (option.locked ? { ...option, locked: false } : option));
    }
  },
  watch: {
    value(val) {
      this.internalValue = val;
      this.collectUnmanagedEmployees(val);
    },
    contactEmployees(val) {
      this.collectUnmanagedEmployees(val);
    },
    internalValue(val){
      this.$emit('input', val);
    },
    // selectionValue (){
    //   this.arrayError = true;
    // },
    // selectOptions(newOptions) {
    //   this.internalValue = newOptions.map(option => option.value);
    //   this.$emit('input', this.internalValue);
    //   if(this.selectOptions.length  === 0 && !this.arrayError && this.item.require){
    //     this.internalValue = '';
    //     this.$emit('input', this.internalValue);
    //     this.$emit('errorSelectOption');
    //   }
    // },
    // 'app.storageList': {
    //   handler(newList) {
    //     if (this.item.name === 'storage' && newList && newList.length > 0 && !this.internalValue) {
    //       // this.internalValue = newList[0].id;
    //     }
    //   },
    //   immediate: true,
    //   deep: true
    // },
  },
  methods: {
    handleNumberInput(e) {
      if (this.item.columnType !== "ArrayNumber") return

      const value = e.target.value

      if (e.key === "Enter") {
        if (!value) return

        if (!/^-?\d+(\.\d+)?$/.test(value)) {
          e.preventDefault()
          this.$message.error("Chỉ được nhập số hoặc số thập phân")
          return
        }
      }

      const allowKeys = [
        "Backspace",
        "Delete",
        "ArrowLeft",
        "ArrowRight",
        "Tab",
        "Enter"
      ]

      if (allowKeys.includes(e.key)) return

      // cho phép số
      if (/^[0-9]$/.test(e.key)) return

      // cho phép dấu .
      if (e.key === ".") {
        if (!value.includes(".")) return
      }

      // cho phép dấu - nhưng chỉ ở đầu
      if (e.key === "-") {
        if (value.length === 0) return
      }

      e.preventDefault()
    },
    isNumber(evt) {
      const charCode = evt.which ? evt.which : evt.keyCode;
      const input = evt.target;
      const inputValue = input.value;
      const cursorPos = input.selectionStart;

      if (charCode >= 48 && charCode <= 57) return; 

      if (charCode === 46 && !inputValue.includes('.')) return; 

      if (charCode === 45 && cursorPos === 0 && !inputValue.includes('-')) return; 

      evt.preventDefault();
    },
    handleKeyDown(e) {
      if ((e.ctrlKey || e.metaKey) && ['c', 'v', 'x', 'a'].includes(e.key.toLowerCase())) {
        return;
      }
			if ([';', '-'].includes(e.key)) {
				e.preventDefault();
			}
			if (/^[a-df-zA-DF-Z]$/.test(e.key)) {
				e.preventDefault();
			}
		},
    // Chỉ thêm, không bao giờ bớt: el-select vừa gỡ tag thì nhân viên đó vẫn
    // phải còn trong options, nếu không sẽ không chèn lại được.
    collectUnmanagedEmployees(val) {
      if (this.item.columnType !== 'Employees' || !Array.isArray(val)) return;
      const teamIds = new Set((this.app.employeeTeam || []).map(e => e.id));
      val.forEach(item => {
        const employee = item && typeof item === 'object' ? item : null;
        const id = employee ? employee.id : item;
        if (id == null || teamIds.has(id)) return;
        if (this.unmanagedEmployees.some(e => e.id === id)) return;
        this.unmanagedEmployees.push(employee ? { ...employee } : { id });
      });
    },
    updateEmployeeValue(val) {
      const next = Array.isArray(val) ? [...val] : [];
      if (this.lockUnmanagedEmployees) {
        // Tag của el-select vẫn có nút x dù option đã disabled, nên phải
        // chèn lại nhân viên ngoài quyền quản lý ở đây.
        this.unmanagedEmployees.forEach(({ id }) => {
          if (!next.includes(id)) next.push(id);
        });
      }
      this.updateValue(next);
    },
    updateValue(val) {
      if(this.item.columnType == 'Date'){
        if (!val || val === '' || isNaN(new Date(val).getTime())) {
          this.internalValue = null;
        } else {
          this.internalValue = val;
        }
      }else{
        this.internalValue = val;
      }
      this.$emit('input', val);
    },
    // handleKeyup(event) {
    //   if (event.key === 'Backspace') {
    //     if (!this.selectionValue.trim() && this.selectOptions.length > 0) {
    //       const lastOption = this.selectOptions[this.selectOptions.length - 1];
    //       this.removeOption(lastOption.id);
    //     }
    //     if(this.selectOptions.length === 0){
    //       this.arrayError = false;
    //     }
    //   } else if (event.key === 'Enter') {
    //     this.addOption();
    //   }
    // },
    // addOption() {
    //   const trimmedValue = this.selectionValue.trim();
    //   if (trimmedValue) {
    //     const exists = this.selectOptions.some(item => item.value.toLowerCase() === trimmedValue.toLowerCase());
    //     if (!exists) {
    //       const newId = this.selectOptions.length > 0 ? this.selectOptions[this.selectOptions.length - 1].id + 1 : 1;
    //       this.selectOptions.push({ id: newId, value: trimmedValue });
    //       this.internalValue = this.selectOptions.map(option => option.value); 
    //       this.$emit('input', this.internalValue);
    //       this.selectionValue = ''; 
    //       this.arrayError = true;
    //       this.$emit('successSelectOption')
    //     } else {
    //       this.alert("error", "Đã tồn tại lựa chọn này!");
    //     }
    //   }
    // },
    // removeOption(id) {
    //   this.selectOptions = this.selectOptions.filter(item => item.id !== id);
    //   this.internalValue = this.selectOptions.map(option => option.value);
    //   this.$emit('input', this.internalValue); 
    //   if(this.selectOptions.length === 0 && this.item.require){
    //     this.arrayError = false;
    //     this.$emit('errorSelectOption');
    //   }
    // },
  },
  created() {
    this.collectUnmanagedEmployees(this.contactEmployees);
    this.collectUnmanagedEmployees(this.value);

    if (this.item.name === 'storage' && this.app?.storageList?.length > 0) {
      this.internalValue = this.internalValue ? this.internalValue : null;
      this.$emit('input', this.internalValue);
    }
    
    // if (Array.isArray(this.value)) {
    //   this.selectOptions = this.value
    //   console.log(123,this.selectOptions);
      
    // }
  },
  mounted() {
  }
}
</script>

<style lang="scss" scoped>
p {
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 1%;
}
.custom-pick-date {
  ::v-deep input {
    padding: 0 15px !important;
  }

  ::v-deep .el-input__prefix {
    right: 15px !important;
    left: auto !important;
  }
}

.list-select {
  border: 1px #ddd solid;
  border-radius: 4px;
}
.list-select.disable {
  background: #f5f7fa;
}

.tag{
  max-width: 365px;
  min-width: max-content; 
  padding: 4px 8px;
  border-radius: 4px;
  background: #f4f5f5;
}

.input-select{
  ::v-deep input {
    border: none;
    padding: 0;
  }
}

.error-message {
  margin-left: 4px;
  color: #CF4547;
  font-size: 12px;
  margin-top: 4px;
  font-style: italic;
}
.text-overflow {
  white-space: nowrap;        
  overflow: hidden;    
  text-overflow: ellipsis;  
  font-size: 10px;  
  color: #909399;
}

::v-deep(.el-tag__close) {
  display: block !important;
}
</style>
